export default [
  {
    name: 'applyInvoice',
    path: '/invoice/apply',
    meta: { title: '申请开票' },
    component: () =>
      import(
        /* webpackChunkName: "applyInvoice" */ '../../pages/invoice/apply.vue'
      )
  },
  {
    name: 'invoiceDetails',
    path: '/invoice/details',
    meta: { title: '发票详情' },
    component: () =>
      import(
        /* webpackChunkName: "applyInvoice" */ '../../pages/invoice/details.vue'
      )
  }
]
